export default "/images/compass.svg?d03702e2ce6c832f5c9d020faa58cacf";